module.exports = __webpack_public_path__ + "img/img7.8a0f5439.svg";